var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25L10.3659 15.6341M10.3659 15.6341L5.28964 10.5579C4.52895 9.79725 4.50626 8.57112 5.23826 7.78281L10.1243 2.52087C10.8957 1.69018 12.2026 1.66599 13.0041 2.46756L23.5324 12.9959C24.334 13.7974 24.3098 15.1043 23.4791 15.8757L18.2172 20.7617C17.4289 21.4937 16.2028 21.471 15.4421 20.7104L10.3659 15.6341Z",
    stroke: "#00FDCE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinting);
export default __webpack_public_path__ + "static/media/minting.f4d77bdedc3b2c5bf2f8663a10b64d21.svg";
export { ForwardRef as ReactComponent };